export default {"src":"/_next/static/media/47-icon.3d206754.svg","height":28,"width":46,"blurWidth":0,"blurHeight":0};